import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface, MultiLineData } from '../../types/global';
import { BenefitGraphRequest, LineGraphData } from '../../api-models';

export default class PostBenefitGraphData extends BaseAdapter<LineGraphData[]> implements AdapterInterface {
  rawResponse: LineGraphData[];

  modifiedRequest: BenefitGraphRequest;

  async adaptResponse(request: { liftDataId: string, wardName: string, benefitCardName: string }): Promise<MultiLineData[]> {
    await this.fetchApiResponse('/api/graph/benefits', HTTPMethod.Post, this.adaptRequest(request));
    return this.rawResponse;
  }

  adaptRequest(request: { liftDataId: string, wardName: string, benefitCardName: string }): BenefitGraphRequest {
    const liftDataId = request.liftDataId === String(All.value) ? null : Number(request.liftDataId);
    this.modifiedRequest = {
      lift_data_id: liftDataId,
      ward_name: request.wardName,
      benefit_card_name: request.benefitCardName,
    };

    return this.modifiedRequest;
  }
}
